import SimpleCryptoEncrypter from "./SimpleCryptoEncrypter";

export default class EncrypterFactory {
  public static simpleCryptoEncrypter = () => {
    return new SimpleCryptoEncrypter();
  };
};
